import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import Loading from 'src/components/common/Loading/Loading';
import { WrapperButton } from '../styles';
import { ButtonSelection } from 'src/components/common/ButtonSelection/ButtonSelection';

export const typeForm = {
    create: 'Crear',
    edit: 'Editar',
};

type PropsForm = {
    type?: 'users' | 'propierties';
    handleSearch?: Function;
    loadingList?: boolean;
    resetValues?: Function;
};

const initialValues = {
    from_xml: '0',
    list: '',
};

const Form = ({ type, loadingList, handleSearch, resetValues }: PropsForm) => {
    const validationSchema = yup.object({
        list: yup.string().required('Debe escribir valores separados por comas'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: (values: any) => {
            resetValues();
            handleSearch(values);
        },
    });

    const handleResetForm = () => {
        formik.resetForm();
        resetValues();
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <ButtonSelection
                    listOptions={[
                        { label: 'Manual', value: '0', enabled: true },
                        { label: 'Feed', value: '1', enabled: true },
                    ]}
                    onChange={(e) => formik.setFieldValue('from_xml', e.value, false)}
                    label="Selecciona el tipo de anunciante"
                    defaultValue={formik.values.from_xml}
                />
                <TextField
                    dataId="list"
                    name="list"
                    label={`${type === 'users' ? 'Emails' : 'Propiedades'}`}
                    originType="pcom"
                    placeHolder="Digite los valores separados por comas"
                    innerLabel
                    value={formik.values.list}
                    onChange={(_, _vale, e) => formik.handleChange(e)}
                    error={Boolean(formik.errors.list)}
                    errorMessage={JSON.stringify(formik.errors.list)}
                    maxLength={3000}
                />
                <WrapperButton>
                    {!loadingList ? (
                        <>
                            <Button dataId="button-search" originType="pcom" size="large" type="submit">
                                Buscar
                            </Button>
                            <Button dataId="button-search" originType="pcom" variant="stroke" size="large" type="button" onClick={handleResetForm}>
                                Reestablecer valores
                            </Button>
                        </>
                    ) : (
                        <Loading className="loader-button" />
                    )}
                </WrapperButton>
            </form>
        </>
    );
};

export default Form;
